import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

export type FormRowProps = {
  title?: string;
  children: React.ReactNode;
  className?: string;
  layout?: 'horizontal' | 'vertical';
  required?: boolean;
  showError?: boolean;
  errorMessage?: string;
};

export const FormRow: React.FC<FormRowProps> = ({
  title,
  children,
  className = '',
  layout = 'horizontal',
  required = false,
  showError = false,
  errorMessage = '',
}) => {
  const isVertical = layout === 'vertical';

  const containerClass = isVertical
    ? 'flex flex-col space-y-1'
    : 'grid grid-cols-12 items-center gap-4';

  const titleClass = isVertical ? 'text-sm font-bold text-left' : 'col-span-4 font-medium pl-4';

  const childrenContainerClass = isVertical ? '' : 'col-span-8 flex justify-start font-light';

  return (
    <div className={`${containerClass} ${className}`}>
      {title && <div className={titleClass}>{`${title} ${required ? '*' : ''}`}</div>}
      <div className={childrenContainerClass}>{children}</div>

      {showError && (
        <div className={`col-span-12 ${isVertical ? '' : 'col-start-5'}`}>
          <div className="mt-1 flex items-center justify-start text-xs text-red-500">
            <ExclamationCircleIcon className="mr-1 size-3" />
            <span>{errorMessage}</span>
          </div>
        </div>
      )}
    </div>
  );
};
